const oultet = () => ({})
const detOultet = () => ({})
const pagination = () => ({
	limit: 20,
	offset: 0,
	length: 0,
	pageNumber: 0,
});
const filter = () => ({
	sortBy: "nama",
	orderBy: "ASC",
})
const search = () => ({
	key: "",
})

const state = {
	outlet: oultet(),
	detailOultet: detOultet(),
	pagination: pagination(),
	filter: filter(),
	search: search(),
	isSearchOutlet: false,
}

export {
	state as default,
	oultet,
	detOultet,
	pagination,
	filter,
	search,
}